import React from 'react';

import withModal from '../../../../../../components/global/modal/withModal';
import RosterIdentityTagAssignment from '.';

export const IDENTITY_TAG_ASSIGNMENT_MODAL =
  'modals/IDENTITY_TAG_SELECTION_MODAL';

const RosterIdentityTagAssignmentModal = props => (
  <RosterIdentityTagAssignment {...props} />
);

export default withModal(RosterIdentityTagAssignmentModal, {
  name: IDENTITY_TAG_ASSIGNMENT_MODAL,
  size: 'sm',
  type: 'full',
  hideHeader: true,
  overlayClassName: 'z-modal-max',
});
